export default __webpack_public_path__ + "static/media/barbarian.7fc269eb.png";